<div class="app-shell workspace-shell">
  <header class="workspace-topbar">
    <div class="topbar-summary">
      <div class="workspace-heading">
        <p class="eyebrow">{{ i18n.translate('heatmap.workspace.eyebrow') }}</p>
        <h1>{{ i18n.translate('heatmap.workspace.title') }}</h1>
        <p class="workspace-description">{{ i18n.translate('heatmap.workspace.description') }}</p>
      </div>

      <div class="workspace-context">
        <div class="context-pill">
          <span class="context-label">{{ i18n.translate('heatmap.workspace.project') }}</span>
          <select class="context-select" [value]="selectedProjectId" (change)="onProjectSelect($event)">
            <option value="">{{ projectsLoading ? i18n.translate('heatmap.workspace.loadingProjects') : i18n.translate('heatmap.workspace.selectProject') }}</option>
            <option *ngFor="let project of projects" [value]="project.projectId">{{ project.name }}</option>
          </select>
        </div>
        <div class="context-pill">
          <span class="context-label">{{ i18n.translate('heatmap.workspace.floorplan') }}</span>
          <select class="context-select" [value]="selectedFloorplanId" (change)="onFloorplanSelect($event)" [disabled]="!selectedProjectId || floorplansLoading">
            <option value="">{{ floorplansLoading ? i18n.translate('heatmap.workspace.loadingFloorplans') : i18n.translate('heatmap.workspace.selectFloorplan') }}</option>
            <option *ngFor="let floorplan of floorplans" [value]="floorplan.floorPlanId">{{ floorplan.name }}</option>
          </select>
        </div>
        <div class="context-pill status-pill" [attr.data-tone]="scenarioStateTone">
          <span class="context-label">{{ i18n.translate('heatmap.workspace.scenarioStatus') }}</span>
          <strong>{{ scenarioStateLabel }}</strong>
          <small *ngIf="scenarioSavedAt">{{ i18n.translate('heatmap.workspace.savedAt') }} {{ scenarioSavedAt }}</small>
        </div>
      </div>
    </div>

    <div class="topbar-actions">
      <div class="topbar-toolbar">
        <div class="panel-switches">
          <div class="panel-popover-group">
            <button
              type="button"
              class="ghost panel-toggle"
              [class.is-active]="activeTopbarPanel === 'workflow'"
              (click)="toggleTopbarPanel('workflow')"
            >
              {{ i18n.translate('heatmap.workspace.scenarioTitle') }}
            </button>

            <section class="topbar-popover" *ngIf="activeTopbarPanel === 'workflow'">
              <div class="card-header">
                <div>
                  <p class="eyebrow">{{ i18n.translate('heatmap.workspace.scenarioEyebrow') }}</p>
                  <h2>{{ i18n.translate('heatmap.workspace.scenarioTitle') }}</h2>
                </div>
              </div>
              <div class="scenario-stages">
                <div class="stage" [class.is-active]="true">
                  <span class="stage-index">1</span>
                  <div>
                    <strong>{{ i18n.translate('heatmap.workspace.stageSetup') }}</strong>
                    <p>{{ workspaceFloorplanName }}</p>
                  </div>
                </div>
                <div class="stage" [class.is-active]="workspaceMode === 'edit' || needsSimulation">
                  <span class="stage-index">2</span>
                  <div>
                    <strong>{{ i18n.translate('heatmap.workspace.stageEdit') }}</strong>
                    <p>{{ accessPoints.length }} AP, {{ obstacles.length }} {{ i18n.translate('heatmap.workspace.obstaclesShort') }}</p>
                  </div>
                </div>
                <div class="stage" [class.is-active]="loading">
                  <span class="stage-index">3</span>
                  <div>
                    <strong>{{ i18n.translate('heatmap.workspace.stageSimulate') }}</strong>
                    <p>{{ loading ? i18n.translate('heatmap.status.simulating') : i18n.translate('heatmap.workspace.readyToRun') }}</p>
                  </div>
                </div>
                <div class="stage" [class.is-active]="workspaceMode === 'analyze' && analysisReady">
                  <span class="stage-index">4</span>
                  <div>
                    <strong>{{ i18n.translate('heatmap.workspace.stageAnalyze') }}</strong>
                    <p>{{ analysisReady ? i18n.translate('heatmap.workspace.analysisAvailable') : i18n.translate('heatmap.workspace.analysisPending') }}</p>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div class="panel-popover-group">
            <button
              type="button"
              class="ghost panel-toggle"
              [class.is-active]="activeTopbarPanel === 'scenario'"
              (click)="toggleTopbarPanel('scenario')"
            >
              {{ i18n.translate('heatmap.workspace.quickActionsTitle') }}
            </button>

            <section class="topbar-popover wide" *ngIf="activeTopbarPanel === 'scenario'">
              <div class="card-header">
                <div>
                  <p class="eyebrow">{{ i18n.translate('heatmap.workspace.quickActionsEyebrow') }}</p>
                  <h2>{{ i18n.translate('heatmap.workspace.quickActionsTitle') }}</h2>
                </div>
              </div>
              <div class="topbar-panel-grid">
                <div class="entity-controls">
                  <div class="entity-group">
                    <label class="entity-label" for="heatmap-antenna-select">{{ i18n.translate('heatmap.actions.selectAntenna') }}</label>
                    <div class="entity-row">
                      <select
                        id="heatmap-antenna-select"
                        class="entity-select"
                        [value]="selectedAntennaValue"
                        (change)="onAntennaSelectChange($event)"
                      >
                        <option value="">{{ i18n.translate('heatmap.actions.selectAntenna') }}</option>
                        <option *ngFor="let antenna of antennaCatalog" [value]="antenna.antennaId">
                          {{ antenna.name }} · {{ antenna.model }}
                        </option>
                      </select>
                      <button type="button" class="ghost" (click)="addAccessPoint()" [disabled]="!antennaCatalog.length">
                        {{ i18n.translate('heatmap.actions.addAntenna') }}
                      </button>
                    </div>
                  </div>

                  <div class="entity-group">
                    <label class="entity-label" for="heatmap-obstacle-select">{{ i18n.translate('heatmap.actions.selectObstacle') }}</label>
                    <div class="entity-row">
                      <select
                        id="heatmap-obstacle-select"
                        class="entity-select"
                        [value]="selectedObstacleValue"
                        (change)="onObstacleSelectChange($event)"
                      >
                        <option value="">{{ i18n.translate('heatmap.actions.selectObstacle') }}</option>
                        <option *ngFor="let obstacle of obstacleCatalog" [value]="obstacle.materialId">
                          {{ obstacle.name }}
                        </option>
                      </select>
                      <button type="button" class="ghost" (click)="addObstacle()" [disabled]="!obstacleCatalog.length">
                        {{ i18n.translate('heatmap.actions.addObstacle') }}
                      </button>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="tool-grid">
                    <button type="button" class="ghost block tool-button" [class.is-active]="activeTool === 'select'" (click)="setInteractionTool('select')">
                      {{ i18n.translate('heatmap.workspace.toolSelect') }}
                    </button>
                    <button type="button" class="ghost block tool-button" [class.is-active]="activeTool === 'measure'" (click)="setInteractionTool('measure')">
                      {{ i18n.translate('heatmap.workspace.toolMeasure') }}
                    </button>
                    <button type="button" class="ghost block tool-button" [class.is-active]="activeTool === 'pan'" (click)="setInteractionTool('pan')">
                      {{ i18n.translate('heatmap.workspace.toolPan') }}
                    </button>
                    <button type="button" class="ghost block" (click)="resetView()">
                      {{ i18n.translate('heatmap.workspace.resetView') }}
                    </button>
                  </div>
                  <p class="tool-hint">{{ i18n.translate('heatmap.workspace.toolHint') }}</p>
                </div>
              </div>
            </section>
          </div>

          <div class="panel-popover-group">
            <button
              type="button"
              class="ghost panel-toggle"
              [class.is-active]="activeTopbarPanel === 'analysis'"
              (click)="toggleTopbarPanel('analysis')"
            >
              {{ i18n.translate('heatmap.workspace.inspectorAnalyzeTitle') }}
            </button>

            <section class="topbar-popover wide align-right" *ngIf="activeTopbarPanel === 'analysis'">
              <div class="card-header">
                <div>
                  <p class="eyebrow">{{ i18n.translate('heatmap.workspace.inspectorEyebrow') }}</p>
                  <h2>{{ i18n.translate('heatmap.workspace.inspectorAnalyzeTitle') }}</h2>
                </div>
              </div>
              <div class="topbar-panel-grid">
                <div>
                  <div class="analysis-grid">
                    <div class="analysis-card">
                      <span>{{ i18n.translate('heatmap.workspace.kpiAverage') }}</span>
                      <strong>{{ formatMetric(averageSignal, ' dBm') }}</strong>
                    </div>
                    <div class="analysis-card">
                      <span>{{ i18n.translate('heatmap.workspace.kpiBest') }}</span>
                      <strong>{{ formatMetric(bestSignal, ' dBm') }}</strong>
                    </div>
                    <div class="analysis-card">
                      <span>{{ i18n.translate('heatmap.workspace.kpiCoverage') }}</span>
                      <strong>{{ formatMetric(coveragePercentage, '%') }}</strong>
                    </div>
                  </div>
                  <p class="inspector-copy">{{ i18n.translate('heatmap.workspace.inspectorAnalyzeCopy') }}</p>
                </div>

                <div class="metric-list">
                  <div class="metric-item">
                    <span>{{ i18n.translate('heatmap.workspace.apCount') }}</span>
                    <strong>{{ accessPoints.length }}</strong>
                  </div>
                  <div class="metric-item">
                    <span>{{ i18n.translate('heatmap.workspace.obstacleCount') }}</span>
                    <strong>{{ obstacles.length }}</strong>
                  </div>
                  <div class="metric-item">
                    <span>{{ i18n.translate('heatmap.workspace.pointDensity') }}</span>
                    <strong>{{ cellSize }} px</strong>
                  </div>
                  <div class="metric-item">
                    <span>{{ i18n.translate('heatmap.workspace.observerHeight') }}</span>
                    <strong>{{ observationHeight }} m</strong>
                  </div>
                  <div class="metric-item">
                    <span>{{ i18n.translate('heatmap.workspace.measurement') }}</span>
                    <strong>{{ measurementLabel }}</strong>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div class="action-buttons">
          <button type="button" class="ghost" (click)="openConfigModal()">
            {{ i18n.translate('heatmap.workspace.configure') }}
          </button>
          <button type="button" class="ghost" (click)="saveScenario()">
            {{ i18n.translate('heatmap.workspace.save') }}
          </button>
          <button type="button" class="ghost" (click)="exportPdf()">
            {{ i18n.translate('heatmap.actions.exportPdf') }}
          </button>
          <button type="button" class="primary" (click)="simulateCoverage()" [disabled]="loading || !accessPoints.length">
            {{ i18n.translate('heatmap.workspace.runSimulation') }}
          </button>
        </div>
      </div>

    </div>
  </header>

  <main class="workspace-grid" [class.has-context-panel]="hasContextPanel">
    <section class="workspace-center">
      <div class="side-card viewer-shell">
        <div class="viewer-topbar">
          <div>
            <p class="eyebrow">{{ i18n.translate('heatmap.workspace.canvasEyebrow') }}</p>
            <h2>{{ i18n.translate('heatmap.workspace.canvasTitle') }}</h2>
            <p class="viewer-note">
              {{ workspaceMode === 'edit'
                ? i18n.translate('heatmap.workspace.canvasEditHint')
                : i18n.translate('heatmap.workspace.canvasAnalyzeHint') }}
            </p>
          </div>
          <div class="viewer-controls">
            <label class="kys-pill kys-pill-select">
              <span class="kys-pill-label">{{ i18n.translate('heatmap.visualization.label') }}</span>
              <select [value]="mode" (change)="onModeSelect($event)" [attr.aria-label]="i18n.translate('heatmap.visualization.aria')">
                <option *ngFor="let option of modeOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </label>
            <div class="kys-opacity">
              <div class="kys-ring">
                <span>{{ (heatmapOpacity * 100) | number: '1.0-0' }}%</span>
              </div>
              <input
                type="range"
                min="0.05"
                max="1"
                step="0.05"
                [value]="heatmapOpacity"
                (input)="onHeatmapOpacityChange($event)"
                [attr.aria-label]="i18n.translate('heatmap.opacity.aria')"
              />
            </div>
          </div>
        </div>

        <div class="viewer">
          <div class="workspace-banner" *ngIf="needsSimulation && !loading">
            {{ accessPoints.length
              ? i18n.translate('heatmap.workspace.bannerDirty')
              : (selectedFloorplanId ? i18n.translate('heatmap.workspace.bannerEmpty') : i18n.translate('heatmap.workspace.bannerSelectFloorplan')) }}
          </div>

          <div class="zoom-controls" [attr.aria-label]="i18n.translate('heatmap.zoom.label')">
            <button type="button" class="zoom-button" (click)="zoomOut()" [disabled]="zoom <= minZoom" [attr.aria-label]="i18n.translate('heatmap.zoom.out')">
              <svg class="zoom-icon" viewBox="360 1139 32 32" aria-hidden="true">
                <path
                  d="M373.46 1163.45c-6.29 0-11.389-5.01-11.389-11.2 0-6.19 5.099-11.21 11.389-11.21 6.29 0 11.39 5.02 11.39 11.21 0 6.19-5.1 11.2-11.39 11.2zm18.228 5.8-8.259-8.13a13.02 13.02 0 0 0 3.491-8.87c0-7.32-6.026-13.25-13.46-13.25-7.434 0-13.46 5.93-13.46 13.25 0 7.31 6.026 13.24 13.46 13.24 3.212 0 6.158-1.11 8.472-2.96l8.293 8.16a1.04 1.04 0 0 0 1.463 0 1.03 1.03 0 0 0 0-1.44zm-12.999-17.84h-10.046c-.541 0-.98.43-.98.96 0 .53.439.96.98.96h10.046c.541 0 .98-.43.98-.96 0-.53-.439-.96-.98-.96z"
                ></path>
              </svg>
              <span class="sr-only">{{ i18n.translate('heatmap.zoom.out') }}</span>
            </button>
            <button type="button" class="zoom-button" (click)="zoomIn()" [disabled]="zoom >= maxZoom" [attr.aria-label]="i18n.translate('heatmap.zoom.in')">
              <svg class="zoom-icon" viewBox="308 1139 32 32" aria-hidden="true">
                <path
                  d="M321.46 1163.45c-6.29 0-11.39-5.01-11.39-11.2 0-6.19 5.1-11.21 11.39-11.21 6.29 0 11.39 5.02 11.39 11.21 0 6.19-5.1 11.2-11.39 11.2zm18.228 5.8-8.259-8.13a13.02 13.02 0 0 0 3.491-8.87c0-7.32-6.026-13.25-13.46-13.25-7.434 0-13.46 5.93-13.46 13.25 0 7.31 6.026 13.24 13.46 13.24 3.212 0 6.158-1.11 8.472-2.96l8.293 8.16a1.04 1.04 0 0 0 1.463 0 1.03 1.03 0 0 0 0-1.44zm-13.169-17.84h-3.997v-4c0-.56-.447-1-.999-1-.551 0-.999.44-.999 1v4h-3.995c-.551 0-.999.18-.999.73 0 .56.448 1.27.999 1.27h3.995v4c0 .56.448 1 .999 1 .552 0 .999-.44.999-1v-4h3.997c.551 0 .999-.45.999-1 0-.55-.448-1-.999-1z"
                ></path>
              </svg>
              <span class="sr-only">{{ i18n.translate('heatmap.zoom.in') }}</span>
            </button>
          </div>

          <ng-container *ngIf="!loading && !error; else statusCard">
            <div
              class="coverage-viewport"
              [class.is-panning]="isPanning"
              [class.can-pan]="zoom > 1"
              (pointerdown)="onPanStart($event)"
              (pointermove)="onPanMove($event)"
              (pointerup)="onPanEnd($event)"
              (pointerleave)="onPanEnd()"
              (pointercancel)="onPanEnd()"
            >
              <div class="coverage-zoom" [style.transform]="'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoom + ')'">
                <app-floorplan-coverage
                  #coverage
                  [floorplanUrl]="floorplanUrl"
                  [imageWidth]="imageWidth"
                  [imageHeight]="imageHeight"
                  [points]="points"
                  [mode]="mode"
                  [accessPoints]="accessPoints"
                  [obstacles]="obstacles"
                  [heatmapOpacity]="heatmapOpacity"
                  [interactionTool]="activeTool"
                  (signalHover)="onSignalHover($event)"
                  (accessPointDropped)="onAccessPointDropped($event)"
                  (canvasAction)="onCanvasAction($event)"
                  (measurementChange)="onMeasurementChange($event)"
                  (obstacleChanged)="onObstacleChanged($event)"
                  (contextMenuChange)="onContextMenuChange($event)"
                ></app-floorplan-coverage>
              </div>
            </div>
          </ng-container>

          <ng-template #statusCard>
            <div class="status-card">
              <p *ngIf="loading">{{ i18n.translate('heatmap.status.simulating') }}</p>
              <p *ngIf="error">{{ error }}</p>
            </div>
          </ng-template>
        </div>

        <div class="viewer-footer">
          <div class="kys-scale">
            <div class="kys-scale-header">
              <span>dBm</span>
            </div>
            <div class="kys-scale-bar" aria-hidden="true">
              <span
                class="kys-scale-segment"
                *ngFor="let color of palette; let i = index"
                [style.background]="color"
                [class.is-active]="hoveredScaleIndex === i"
                [class.is-dim]="hoveredScaleIndex !== null && hoveredScaleIndex !== i"
              ></span>
            </div>
            <div class="kys-scale-labels">
              <span
                *ngFor="let threshold of thresholds; let i = index"
                [class.is-active]="hoveredScaleIndex === i"
                [class.is-dim]="hoveredScaleIndex !== null && hoveredScaleIndex !== i"
              >
                {{ threshold }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <aside class="workspace-side insight-panel" *ngIf="contextSelection">
        <app-coverage-context-panel
          class="coverage-panel"
          [selection]="contextSelection"
          [accessPoints]="accessPoints"
          [obstacles]="obstacles"
          (close)="onPanelClose()"
          (antennaHeightChange)="onPanelAntennaHeightChange($event)"
          (obstacleMaterialChange)="onPanelObstacleMaterialChange($event)"
          (obstacleLossChange)="onPanelObstacleLossChange($event)"
          (obstacleThicknessChange)="onPanelObstacleThicknessChange($event)"
          (obstacleHeightChange)="onPanelObstacleHeightChange($event)"
          (deleteAntenna)="onPanelDeleteAntenna($event)"
          (deleteObstacle)="onPanelDeleteObstacle($event)"
        ></app-coverage-context-panel>
    </aside>
  </main>

  <div class="modal-backdrop" *ngIf="showConfigModal">
    <div class="modal">
      <header class="modal-header">
        <div>
          <h2>{{ i18n.translate('heatmap.modal.title') }}</h2>
          <p>{{ i18n.translate('heatmap.modal.subtitle') }}</p>
        </div>
        <button type="button" class="icon-button" [attr.aria-label]="i18n.translate('heatmap.modal.close')" (click)="closeConfigModal()">✕</button>
      </header>

      <div class="modal-body">
        <div class="form-grid">
          <label class="field">
            <span>{{ i18n.translate('heatmap.modal.density') }}</span>
            <input type="number" min="5" max="100" step="1" [value]="cellSize" (input)="onCellSizeChange($event)" />
            <small>{{ i18n.translate('heatmap.modal.densityHint') }}</small>
          </label>
          <label class="field">
            <span>{{ i18n.translate('heatmap.modal.observationHeight') }}</span>
            <input type="number" min="0.1" max="10" step="0.1" [value]="observationHeight" (input)="onObservationHeightChange($event)" />
            <small>{{ i18n.translate('heatmap.modal.observationHeightHint') }}</small>
          </label>
          <label class="field checkbox">
            <input type="checkbox" [checked]="randomizePositions" (change)="onRandomizeToggle($event)" />
            <span>{{ i18n.translate('heatmap.modal.randomizeToggle') }}</span>
          </label>
          <button type="button" class="ghost inline" (click)="randomizeConfigText()">{{ i18n.translate('heatmap.modal.randomizeNow') }}</button>
        </div>
        <label class="textarea-label">
          <span>{{ i18n.translate('heatmap.modal.configJson') }}</span>
          <textarea [value]="configText" (input)="onConfigTextChange($event)" spellcheck="false"></textarea>
        </label>
        <p class="hint">
          {{ i18n.translate('heatmap.modal.requiredFields') }} <code>width</code>, <code>height</code>, <code>cell</code>, <code>aps</code>,
          <code>obstacles</code>.
          {{ i18n.translate('heatmap.modal.optionalFields') }} <code>noiseAmplitude</code> (default {{ defaultConfig.noiseAmplitude }}).
        </p>
        <p *ngIf="configError" class="error">{{ configError }}</p>
      </div>

      <footer class="modal-actions">
        <button type="button" class="ghost" (click)="resetConfigText()">{{ i18n.translate('heatmap.modal.reset') }}</button>
        <div class="spacer"></div>
        <button type="button" class="ghost" (click)="closeConfigModal()">{{ i18n.translate('heatmap.modal.cancel') }}</button>
        <button type="button" class="primary" (click)="applyConfigFromModal()">{{ i18n.translate('heatmap.modal.regenerate') }}</button>
      </footer>
    </div>
  </div>
</div>
